import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetCategories } from '../utils/categoryAPI';
import { setCategries } from '../features/categoriesSlice';
import {
  Box, Grid, Card, CardActionArea, CardContent, CardMedia,
  Typography, Stack, Button, Popover, List, ListItemButton, ListItemText, Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function Categories() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const categories = useSelector((s) => s.categories?.categories || []);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  // --- חדש: state עבור החלונית ---
  const [anchorEl, setAnchorEl] = useState(null);
  const [openRootId, setOpenRootId] = useState(null);

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        setLoading(true);
        setErr('');
        const data = await GetCategories();
        if (!ignore) dispatch(setCategries(data));
      } catch (e) {
        if (!ignore) setErr('שגיאה בטעינת קטגוריות');
        console.error(e);
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, [dispatch]);

  const getParentId = (c) => c.parentCategoryId ?? c.parentCategoryID ?? c.parentcategoryid ?? null;

  const roots = useMemo(
    () => categories.filter((c) => getParentId(c) == null),
    [categories]
  );

  const childrenByParent = useMemo(() => {
    const map = new Map();
    for (const c of categories) {
      const pid = getParentId(c);
      if (pid == null) continue;
      if (!map.has(pid)) map.set(pid, []);
      map.get(pid).push(c);
    }
    for (const arr of map.values()) {
      arr.sort((a, b) => (a.nameCategor || '').localeCompare(b.nameCategor || ''));
    }
    return map;
  }, [categories]);

  const goToCategory = (id) => navigate(`/categories/${id}`);

  // --- חדש: פתיחה/סגירה של החלונית ---
  const handleOpen = (event, rootId) => {
    setAnchorEl(event.currentTarget);
    setOpenRootId(rootId);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenRootId(null);
  };

  if (loading) return <div>טוען…</div>;
  if (err) return <div style={{ color: 'red' }}>{err}</div>;

  const open = Boolean(anchorEl);
  const currentChildren = openRootId != null ? (childrenByParent.get(openRootId) || []) : [];

  return (
    <Box dir="rtl">
      <Grid container spacing={4}>
        {roots.map((root) => (
          <Grid item key={root.id} xs={12} sm={6} md={4}>
            <Card>
              <CardActionArea onClick={(e) => handleOpen(e, root.id)}>
                <CardMedia
                  component="img"
                  alt={root.nameCategor}
                  height="140"
                  image={root.pathToImage || '/placeholder.jpg'}
                />
                <CardContent>
                  <Typography gutterBottom variant="h5">
                    {root.nameCategor}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    לחצי להצגת תתי־קטגוריות
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* --- חלונית תתי־קטגוריות --- */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 2,
            borderRadius: 2,
            minWidth: 300,
            maxWidth: 520,
            maxHeight: 420,
            overflowY: 'auto',
            boxShadow: 6,
          },
          onMouseLeave: handleClose, // אופציונלי: נסגר ביציאה עם העכבר
        }}
      >
        <Box>
          <Typography variant="subtitle1" sx={{ px: 1, pb: 1, fontWeight: 700 }}>
            תתי־קטגוריות
          </Typography>
          <List dense disablePadding>
            <Grid container spacing={0.5}>
              {currentChildren.length > 0 ? (
                currentChildren.map((child) => (
                  <Grid item xs={12} sm={6} key={child.id}>
                    <ListItemButton
                      onClick={() => { handleClose(); goToCategory(child.id); }}
                      sx={{ borderRadius: 1 }}
                    >
                      <ListItemText
                        primary={child.nameCategor}
                        primaryTypographyProps={{ sx: { fontSize: 15 } }}
                      />
                    </ListItemButton>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Box sx={{ px: 1, py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      אין תתי־קטגוריות לקטגוריה זו.
                    </Typography>
                  </Box>
                </Grid>
              )}
            </Grid>
          </List>
          <Divider sx={{ my: 1 }} />
          {/* {openRootId != null && (
            <Button
              fullWidth
              variant="outlined"
              onClick={() => { handleClose(); goToCategory(openRootId); }}
            >
              לכל המוצרים בקטגוריה זו ›
            </Button>
          )} */}
        </Box>
      </Popover>
    </Box>
  );
}